import { array, number, object, string } from '@gogame/schemas';

import { filtersCollectionSchema } from './filtersSchema';
import { tableSettingsSchema } from './tableSettingsSchema';
import { metricsSchema } from './metricsSchema';
import { dimensionSchema } from './dimensionSchema';

export const presetSchema = object({
  filtersCollection: filtersCollectionSchema,
  tableSettings: tableSettingsSchema,
  metrics: metricsSchema,
  selectedIds: array(number()),
  searchQuery: string(),
  dimension: dimensionSchema,
  advancedFilters: array(string()).default([]),
});

export const mapStateToPreset = (screenState) =>
  presetSchema
    .stripDefaults()
    .cast(presetSchema.cast(screenState, { stripUnknown: true, context: {} }), {
      applyConst: true,
      context: {
        stripPayTo: true,
        stripChartLazy: true,
      },
    });
